import type { ReactNode } from "react";

type LinkProps = {
  href: string;
  children: ReactNode;
  className?: string;
  title?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

/** The SPA's anchor: pushState for internal paths, a plain anchor otherwise. */
export function Link({ href, children, className, title, onClick }: LinkProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (event.defaultPrevented) return;
    if (!href.startsWith("/") || href.includes("#") || event.metaKey || event.ctrlKey) return;
    event.preventDefault();
    window.history.pushState({}, "", href);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };
  return (
    <a
      href={href}
      onClick={handleClick}
      className={className}
      title={title}
      target={href.startsWith("https://") ? "_blank" : undefined}
      rel={href.startsWith("https://") ? "noreferrer" : undefined}
    >
      {children}
    </a>
  );
}

export function Arrow() {
  return <span aria-hidden="true">→</span>;
}
